import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopupService } from '../../shared/modal/popup.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InventoryContext } from '../../inventory-manager/inventory.context';
import { HttpResponse } from '@angular/common/http';
import { AlertService } from '../../shared/alert/alert.service';
import { JhiEventManager, JhiLanguageService } from '../../shared/core-utils';
import { TransactionService } from '../../shared/inventory/service/transaction.service';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

const SUCCESS_CONFIRMED = 'inventoryManagerApp.lot.deposit.success.confirmed.transaction';
const SUCCESS_PENDING = 'inventoryManagerApp.lot.deposit.success.pending.transaction';

@Component({
    selector: 'jhi-lot-deposit-dialog',
    templateUrl: './lot-deposit-dialog.component.html'
})
export class LotDepositDialogComponent implements OnInit, OnDestroy {
    searchResultDbId: string;
    totalSelectedLots: number;
    lotsDeposits: any[];
    notes: any;
    confirmDepositTransactions;
    subscriptionsManager = new SubscriptionsManager();

    constructor(private jhiLanguageService: JhiLanguageService,
                private inventoryContext: InventoryContext,
                private activatedRoute: ActivatedRoute,
                private alertService: AlertService,
                public activeModal: NgbActiveModal,
                private transactionService: TransactionService,
                private eventManager: JhiEventManager) {
        this.subscriptionsManager.add = this.activatedRoute.queryParams.subscribe((params) => {
            this.searchResultDbId = params.searchResultDbId;
        });

        this.lotsDeposits = [];
        this.totalSelectedLots = 0;
        this.confirmDepositTransactions = { selected: true };

        this.lotsDeposits = Object.keys(this.inventoryContext.lotsCountByUnitName).map(
            (unit) =>
                this.buildDeposit(unit, this.inventoryContext.lotsCountByUnitName[unit])
        );

        this.totalSelectedLots = this.lotsDeposits.map((depositLot) => depositLot.count).reduce((a, b) => a + b, 0);

    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    private buildDeposit(unitName: string, lotSelected: number) {
        return {
            allAvailableSeed: { selected: false },
            amount: '',
            unit: unitName,
            count: lotSelected
        };
    }

    ngOnInit(): void {
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        const lotDepositRequest = {
            selectedLots: { searchRequest: null, itemIds: null },
            notes: this.notes,
            depositsPerUnit: this.lotsDeposits.reduce((map, obj) => {
                map[obj.unit] = obj.amount;
                return map;
            }, {})
        };

        if (this.searchResultDbId) {
            lotDepositRequest.selectedLots.searchRequest = this.searchResultDbId;
        } else {
            lotDepositRequest.selectedLots.itemIds = this.inventoryContext.itemIds;
        }

        if (this.confirmDepositTransactions.selected) {
            this.subscriptionsManager.add = this.transactionService.createConfirmedDeposits(lotDepositRequest)
                .subscribe(
                    (res: HttpResponse<any>) =>
                        this.onSaveSuccess(SUCCESS_CONFIRMED));
        } else {
            this.subscriptionsManager.add = this.transactionService.createPendingDeposits(lotDepositRequest)
                .subscribe(
                    (res: HttpResponse<any>) =>
                        this.onSaveSuccess(SUCCESS_PENDING));
        }
    }

    private onSaveSuccess(message: any) {
        this.alertService.success(message);
        this.eventManager.broadcast({ name: 'columnFiltersChanged', content: 'OK' });
        this.activeModal.dismiss('saved');
    }

}

@Component({
    selector: 'jhi-lot-deposit-popup',
    template: ''
})
export class LotDepositPopupComponent implements OnInit, OnDestroy {

    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private popupService: PopupService
    ) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(() => {
            this.popupService.open(LotDepositDialogComponent as Component);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}
